module.exports = __webpack_public_path__ + "static/media/graviola-digital-logo.9ec39cd6.svg";